import React from "react";

import TroubleReport from "./TroubleReport";
import illu_nothingFound from "../../../assets/illustrations/illustration_nothingfound.svg";
import TroubleReportButton from "./TroubleReportButton";

import "./TroubleReportControllerStyle.css";

const TroubleReportController = ({ troubleReportData }) => {
  const addReportsToDOM = (data) => {
    let allTroubleReports = [];
    for (let i = 0; i < data.length; i++) {
      const created = new Date(data[i].creationDate);
      allTroubleReports.push(
        <TroubleReport
          headline={data[i].headline}
          content={data[i].content}
          creationDate={
            created.getDate() +
            "." +
            (created.getMonth() + 1) +
            "." +
            created.getFullYear()
          }
          key={data[i].id}
        />
      );
    }
    return allTroubleReports;
  };

  const fallbackScreenForNoTroubleReports = () => {
    return (
      <div className="fallback-trouble-reports">
        <img src={illu_nothingFound} alt="" />
        <span>Keine Störungsmeldungen gefunden.</span>
      </div>
    );
  };

  return (
    <div className="trouble-reports-controller">
      {troubleReportData.length > 0
        ? addReportsToDOM(troubleReportData)
        : fallbackScreenForNoTroubleReports()}

      <TroubleReportButton />
    </div>
  );
};

export default TroubleReportController;
